import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab12',
  templateUrl: './awsop-lab12.component.html',
  styleUrls: ['./awsop-lab12.component.css']
})
export class AwsopLab12Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab12/awsop-lab12.component.ts